import { PlannerPolicyActions } from 'src/store/actions/plannerPolicyActions';
import { toDropDownSelectorOptions } from 'src/components/Inputs/DropDownSelector/instruments';
const initialState = {
    allPolicies: [],
    allPolicyOptions: [],
    allPoliciesLoading: false,
    aggregationTargets: [],
    aggregationOperations: [],
    aggregationOperationsLoading: false,
    aggregationTargetsLoading: false,
    logicalOperators: [],
    logicalOperatorsLoading: false,
    dateTimeDiameters: [],
    dateTimeDiametersLoading: false
};
export default (state = initialState, { type, payload }) => {
    switch (type) {
        case PlannerPolicyActions.GET_ALL_PLANNER_POLICIES_REQUEST: {
            return ({
                ...state,
                allPoliciesLoading: true
            });
        }
        case PlannerPolicyActions.GET_ALL_PLANNER_POLICIES_SUCCESS: {
            const policies = payload?.Data || [];
            return ({
                ...state,
                allPoliciesLoading: false,
                allPolicies: policies,
                allPolicyOptions: toDropDownSelectorOptions(policies, 'Description', 'Id', true)
            });
        }
        case PlannerPolicyActions.GET_ALL_PLANNER_POLICIES_FAIL: {
            return ({
                ...state,
                allPoliciesLoading: false
            });
        }
        case PlannerPolicyActions.GET_AGGREGATION_OPERATIONS_REQUEST: {
            return ({
                ...state,
                aggregationOperationsLoading: true
            });
        }
        case PlannerPolicyActions.GET_AGGREGATION_OPERATIONS_SUCCESS: {
            return ({
                ...state,
                aggregationOperationsLoading: false,
                aggregationOperations: payload?.Data || []
            });
        }
        case PlannerPolicyActions.GET_AGGREGATION_OPERATIONS_FAIL: {
            return ({
                ...state,
                aggregationOperationsLoading: false
            });
        }
        case PlannerPolicyActions.GET_AGGREGATION_TARGETS_REQUEST: {
            return ({
                ...state,
                aggregationTargetsLoading: true
            });
        }
        case PlannerPolicyActions.GET_AGGREGATION_TARGETS_SUCCESS: {
            return ({
                ...state,
                aggregationTargetsLoading: false,
                aggregationTargets: payload?.Data || []
            });
        }
        case PlannerPolicyActions.GET_AGGREGATION_TARGETS_FAIL: {
            return ({
                ...state,
                aggregationTargetsLoading: false
            });
        }
        case PlannerPolicyActions.GET_LOGICAL_OPERATORS_REQUEST: {
            return ({
                ...state,
                logicalOperatorsLoading: true
            });
        }
        case PlannerPolicyActions.GET_LOGICAL_OPERATORS_SUCCESS: {
            return ({
                ...state,
                logicalOperatorsLoading: false,
                logicalOperators: payload?.Data || []
            });
        }
        case PlannerPolicyActions.GET_LOGICAL_OPERATORS_FAIL: {
            return ({
                ...state,
                logicalOperatorsLoading: false
            });
        }
        case PlannerPolicyActions.CREATE_UPDATE_PLANNER_POLICY_SUCCESS: {
            const existingIndex = state.allPolicies.findIndex((item) => item.Id === payload.Id);
            let updatedPolicies;
            if (existingIndex >= 0) {
                // Update existing planner policy
                updatedPolicies = [...state.allPolicies];
                updatedPolicies[existingIndex] = payload;
            }
            else {
                // Add new planner policy
                updatedPolicies = [...state.allPolicies, payload];
            }
            return ({
                ...state,
                allPolicies: updatedPolicies,
                allPolicyOptions: toDropDownSelectorOptions(updatedPolicies, 'Description', 'Id', true)
            });
        }
        case PlannerPolicyActions.DELETE_PLANNER_POLICY_SUCCESS: {
            const updatedPolicies = state.allPolicies.filter((item) => item.Id !== payload);
            return ({
                ...state,
                allPolicies: updatedPolicies,
                allPolicyOptions: toDropDownSelectorOptions(updatedPolicies, 'Description', 'Id', true)
            });
        }
        case PlannerPolicyActions.GET_DATE_TIME_DIAMETERS_REQUEST: {
            return ({
                ...state,
                dateTimeDiametersLoading: true
            });
        }
        case PlannerPolicyActions.GET_DATE_TIME_DIAMETERS_SUCCESS: {
            return ({
                ...state,
                dateTimeDiametersLoading: false,
                dateTimeDiameters: payload?.Data || []
            });
        }
        case PlannerPolicyActions.GET_DATE_TIME_DIAMETERS_FAIL: {
            return ({
                ...state,
                dateTimeDiametersLoading: false
            });
        }
        default: return state;
    }
};
